import { useState } from 'react';
import ImageRequest from '@/assets/img/invite-icon.svg';
import ImageRequestSent from '@/assets/img/request-send-icon.svg';
import ModalDefault from '@/components/Modals/ModalDefault';
import { useUser } from '@/contexts/AuthContext';
import { useLoading } from '@/contexts/LoadingContext';
import { Toast } from '@/lib/Toast';
import { api } from '@/services/apiClient';
import { handleErrorAsync } from '@/utils/handlers';
import { Typography } from '@mui/material';

interface IRequestAccessProps {
  isOpen: boolean;
  handleClose: () => void;
  infoText?: string;
  infoTitle?: string;
}

export default function RequestAccess({
  isOpen,
  handleClose,
  infoText,
  infoTitle,
}: IRequestAccessProps) {
  const [isOpenModalRequestSent, setIsOpenModalRequestSent] = useState(false);
  const { setIsLoading } = useLoading();
  const { defaultMembership } = useUser();

  const handleClickRequest = async () => {
    setIsLoading(true);
    const [_, error] = await handleErrorAsync(async () => {
      return api.post(
        `/api/companies/${defaultMembership?.company.id}/request_access/`
      );
    }).finally(() => {
      setIsLoading(false);
    });

    if (error) return Toast('error', error.message);
    handleClose();
    setIsOpenModalRequestSent(true);
  };

  return (
    <>
      <ModalDefault
        aria-label="modal-request-admin-access"
        isOpen={isOpen}
        onClose={handleClose}
        alt="Imagem representando solicitação"
        src={ImageRequest}
        title={infoTitle || 'Habilitar funcionalidade!'}
        textButton="solicitar acesso"
        onClickButton={handleClickRequest}
      >
        <Typography sx={{ color: 'rgba(0, 0, 0, 0.5)', mb: '20px' }}>
          {infoText ||
            'Para ter acesso a essa funcionalidade, solicite um acesso de  administrador'}
        </Typography>
      </ModalDefault>

      <ModalDefault
        aria-label="modal-request-sent"
        isOpen={isOpenModalRequestSent}
        onClose={() => setIsOpenModalRequestSent(false)}
        alt="Imagem representando que a solicitação foi enviada"
        src={ImageRequestSent}
        title="Solicitação enviada!"
      >
        <Typography sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>
          Sua solicitação de acesso foi enviada para o(s) administrador(es)
        </Typography>
      </ModalDefault>
    </>
  );
}
export type { IRequestAccessProps };
